module.exports = __webpack_public_path__ + "img/name.2ce7f856.png";